import {CanActivateFn, Router} from '@angular/router';
import {AuthenticationService} from "./authentication.service";
import {inject} from "@angular/core";
import { PermissionsService } from './permissions.service';

export const authenticationGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthenticationService);
  const permissionsService = inject(PermissionsService);

  if (authService.validateToken()) {
 

    return true; 
  } else {
    router.navigate(['login']);
    return false;
  }

  
};
